export default {
  submitBtn: false,
  emptyBtn: false,
  group: [
    {
      label: '房产信息',
      prop: 'group1',
      column: [
        {
          label: '上级结构',
          prop: 'parentObjectName',
          disabled: true,
          span: 12,
        },
        {
          label: '房间名称',
          prop: 'objectName',
          disabled: true,
          span: 12,
        },
        {
          label: '速记码',
          prop: 'shortCode',
          disabled: true,
          span: 12,
        },
        {
          label: '房屋性质',
          prop: 'useType',
          type: 'select',
          dataType: 'number',
          dicUrl: 'api/base/property/getUseTypes?code=use_type&remark=1',
          props: { label: 'dictValue', value: 'dictKey' },
          disabled: true,
          span: 12,
        },
        {
          label: '使用面积',
          prop: 'usableArea',
          placeholder: '请输入 建筑面积，单位m2',
          disabled: true,
          span: 12,
        },
        {
          label: '建筑面积',
          prop: 'floorage',
          placeholder: '请输入 建筑面积，单位m2',
          disabled: true,
          span: 12,
        },
        {
          label: '户主姓名',
          prop: 'householdName',
          disabled: true,
          span: 12,
        },
        {
          label: '联系方式',
          prop: 'householdLinkPhone',
          disabled: true,
          span: 12,
        },
        {
          label: '房屋状态',
          prop: 'roomStatus',
          type: 'select',
          dataType: 'number',
          dicUrl: 'api/blade-system/dict/dictionary?code=room_status',
          disabled: true,
          props: { label: 'dictValue', value: 'dictKey' },
          span: 12,
        },
        {
          label: '序号',
          prop: 'indexNum',
          disabled: true,
          span: 12,
        },
      ]
    },
    {
      label: '成员管理',
      prop: 'group2',
      column: [],
    },
  ],
};
